module.exports = __webpack_public_path__ + "assets/img/footer_logo_16.b89359af.png";